import Honeybadger from '@honeybadger-io/js';

// a lot of the functionality below is unknown hence the any types
// TODO: fix typing
export interface IError {
  apiError: string;
  response: any;
  [index: string]: any;
}

const formatErrorResponse = (error: IError, generalErrors = {}) =>
  error.response.json().then((res: { errors: IError }) => {
    const errors = res.errors || {};
    return Object.assign(
      generalErrors,
      ...Object.keys(errors).map((k) => ({ [k]: errors[k].join(', ') }))
    );
  });

const reportError = (error: IError) => {
  console.error('Error:', error);
  Honeybadger.notify(error);
  return error;
};

const handleError = (error: IError, cb?: ((arg0: any) => void) | undefined) => {
  if (cb) cb(error);
  reportError(error);
};

const handleSubmitError = (
  error: IError,
  formActions: { setErrors: (arg0: any) => any; setSubmitting: (arg0: boolean) => void },
  msg: any
) => {
  handleError(error);
  if (error.apiError) {
    formatErrorResponse(error, { submitFailedMsg: msg }).then((parsedErrors: string) =>
      formActions.setErrors(parsedErrors)
    );
  }
  formActions.setSubmitting(false);
};

const logError = (msg: string | Error) => {
  console.error(msg);
  Honeybadger.notify(msg);
};

export { handleError, handleSubmitError, logError };
